module.exports = __webpack_public_path__ + "img/2374782-04-2.b03eddad.png";